<template>
  <el-container>

    <!-- 左侧菜单栏 -->
    <el-aside :width="iscollapse ?'60px':'220px' ">
      <div class="logo"><img src="../assets/images/logo.png" alt=""></div>

      <!-- 菜单列表 -->
      <el-menu text-color="#8b9598" active-text-color="#3c6cfe" :default-active="activePath"  unique-opened router :collapse-transition="false">
        <!-- 遍历一级菜单 -->
        <li v-for="child1 in menuList" :key="child1.id">
          <!-- 一级菜单没有子菜单 -->
          <el-menu-item :index="'/' + child1.permissionsPath" v-if="!child1.children">
              <template slot="title">
                  <i :class="child1.permissionsIconcls"></i>
                  <span slot="title">{{ child1.permissionsName }}</span>
              </template>
          </el-menu-item>
          <!-- 一级菜单有子菜单 -->
          <el-submenu :index="'/' + child1.permissionsPath" v-if="child1.children">
              <template slot="title">
                  <i :class="child1.permissionsIconcls"></i>
                  <span slot="title">{{ child1.permissionsName }}</span>
              </template>
              <!-- 遍历二级菜单 -->
              <li v-for="child2 in child1.children" :key="child2.id">
                <!-- 二级菜单没有子菜单 -->
                <el-menu-item :index="'/' + child2.permissionsPath" v-if="!child2.children">
                    <template slot="title">
                        <!-- <i class="el-icon-caret-right"></i> -->
                        <span slot="title">{{ child2.permissionsName }}</span>
                    </template>
                </el-menu-item>
                <!-- 二级菜单有子菜单 -->
                <el-submenu :index="'/' + child2.permissionsPath" v-if="child2.children">
                    <template slot="title">
                        <i class="el-icon-caret-right"></i>
                        <span slot="title">{{ child2.permissionsName }}</span>
                    </template>
                    <!-- 遍历三级菜单 -->
                    <li v-for="child3 in child2.children" :key="child3.id">
                      <!-- 三级菜单没有子菜单 -->
                      <el-menu-item :index="'/' + child3.permissionsPath">
                          <template slot="title">
                              <!-- <i class="el-icon-caret-right"></i> -->
                              <span slot="title">{{ child3.permissionsName }}</span>
                          </template>
                      </el-menu-item>
                    </li>
                </el-submenu>
              </li>
          </el-submenu>
        </li>
      </el-menu>
    </el-aside>
    <!-- Aside End -->

    <el-container>
      <!-- Head -->
      <el-header>
        <div class="aside_head_title">{{System_Name}}</div>

        <div class="user_info">
          <!-- 头像 -->
          <el-avatar :size="34" src="" @error="errorHandler" class="avatar">
            <img src="../assets/images/avatar.png"/>
          </el-avatar>

          <el-dropdown>
            <span class="el-dropdown-link">
              <span>{{user_name}}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="dialogChangePsd = true">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="dialogSignOut = true">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <!-- Head End -->

      <!-- Main -->
      <el-main :style="defaultHeight">
        <router-view @recvfromchild="recvfromchild"></router-view>
      </el-main>
      <!-- Main 结束 -->

    </el-container>

    <!---------------------- 弹框 ---------------------->
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="dialogChangePsd" width="26%" class="newAdd">
      <div class="change_body">
        <el-form ref="userMsg" :model="changePsdForm" label-width="110px">
          <el-form-item label="旧密码" :required=true>
            <el-input v-model="changePsdForm.userPassword" placeholder="请输入旧密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" :required=true>
            <el-input v-model="changePsdForm.userPassword1" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" :required=true>
            <el-input v-model="changePsdForm.userPassword2" placeholder="请确认新密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changePwdWhenHaveLogin()" >确 认</el-button>
        <el-button type="primary" plain @click="dialogChangePsd = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码 End -->

    <!-- 退出登录 -->
    <el-dialog title="退出登录" :visible.sync="dialogSignOut" width="26%" class="newAdd">
      <div class="addUser_body">
        <h2>确定要退出登录？</h2>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="clickdialogSignOut()" >确 认</el-button>
        <el-button type="primary" plain @click="dialogSignOut = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 退出登录 End -->

  </el-container>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      System_Name: '',
      defaultHeight: {
        height: []
      },
      // 被激活的链接地址
      activePath: [],
      // 是否折叠
      iscollapse: false,
      // 菜单分类数据
      menuList: [],
      changePsdForm: {
        userPassword: '',
        userPassword1: '',
        userPassword2: ''
      },
      dialogChangePsd: false,
      dialogSignOut: false,
      user_name: ''
    }
  },
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
  },
  mounted () {
    this.user_name = localStorage.getItem('userName')
    this.System_Name = Vue.prototype.global.System_Name
    this.getPermissionsTreeForMySelf()
  },
  methods: {
    clickdialogSignOut () {
      this.dialogSignOut = false
      Vue.prototype.Quit('退出登录成功')
    },
    recvfromchild (e) {
      this.activePath = e
      this.$router.push(this.activePath)
    },
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    // 定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 60 + 'px'
    },
    errorHandler () {
      return true
    },
    getPermissionsTreeForMySelf: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getPermissionsTreeForMySelf, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.menuList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changePwdWhenHaveLogin: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.userPassword = that.changePsdForm.userPassword
      data.userPassword1 = that.changePsdForm.userPassword1
      data.userPassword2 = that.changePsdForm.userPassword2
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_changePwdWhenHaveLogin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindAllways(response.data.msg)
          if (response.data.code === 1) {
            that.dialogChangePsd = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

.logo{
  text-align: center;
  padding: 15px 0;
  overflow: hidden;

  & img{
    width: 190px;
    object-fit: contain;
  }
}
.el-header{
  background: #f6f6fa;
}
.aside_head_title{
  color: #333;
  font-size: 22px;
}

.user_info{
  display: flex;
  align-items: center;
}

.avatar{
  margin-right: 12px;
}

.el-menu {
  border-right: 0;
}

.el-aside {
  position: relative;
  // box-shadow: 10px 0 10px -10px #c7c7c7;
}

.el-aside::-webkit-scrollbar {
  display: none;
}

.el-header {
  z-index: 10;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  // box-shadow: 0 10px 10px -10px #ccc;

  .toggle_btn {
    font-size: 26px;
    cursor: pointer;
    color: #b4b2bf;
    z-index: 99;
  }
}

.el-dropdown-link span {
  color: #027aff;
}
/deep/ .el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: #f1f4ff;
}
/deep/ .el-submenu__title:hover {
    background-color: #f1f4ff;
}

.el-main {
  height: calc(100vh - 60px);
}

.appdown{
  margin-right: 30px;

  .el-dropdown-link span[data-v-fae5bece] {
    color: #4976ff;
    padding: 6px 10px;
    background: #eaefff;
    border-radius: 6px;
    border: 1px solid #4976ff;
  }
}
.top_code{
  padding: 4px 4px 0 4px;

  img{
    width: 140px;
    height: 140px;
    object-fit: contain;
  }
}

// 弹窗
.change_body{
  padding: 0 50px 0 30px;
}
// 按钮
/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 弹出样式
.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.addUser_body{
  padding: 0 46px 0 30px;
  h2{
      color: #000;
      font-size: 18px;
  }
}
</style>
